export default __webpack_public_path__ + "static/banner-woocommerce-5037fb8f3530f3552a3979da49338af1.webp";